import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    duration: { type: Number, default: 2000 },
    auto: { type: Boolean, default: false }
  }

  connect() {
    this.className = this.element.dataset.highlightClass || "bg-blue-100"

    if (this.autoValue) {
      this.highlight()
    }
  }

  highlight() {
    if (this.highlighted) return
    this.highlighted = true

    this.element.classList.add(this.className)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.element.classList.remove(this.className)
      this.highlighted = false
    }, this.durationValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
